import React from "react";
import {HomeInfinite} from "../../components/infinite_text/infinite_text";
import HomeButton from "../../components/home_buttons/home_buttons";
import useDocumentTitle from "../../hooks/useDocumentTitle";

export default function Home() {
    useDocumentTitle(
        "Marcelo Colonia — Game Designer & Programmer",
        "Marcelo Colonia is a game designer and programmer based in Lima and Berlin. Graphics programming with OpenGL, custom 2D engines, and the adventure game Capital."
    );
    return (
        <div style={{height: '100%', display: 'flex', flexDirection: 'column', overflowX: 'hidden'}}>
            <HomeInfinite/>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: "center",
                alignContent: 'center',
                alignItems: 'center',
                flex: 1
            }}>
                <HomeButton url={'about'}><div>about</div></HomeButton>
                <HomeButton url={'experience'}><div>experience</div></HomeButton>
                <HomeButton><s>projects</s></HomeButton>
                <HomeButton><s>blog</s></HomeButton>
                <HomeButton><s>articles</s></HomeButton>
            </div>
        </div>
    )
}